(() => {
  if (window.tclTvSizePopup) {
    window.tclTvSizePopup.init();
    return;
  }
  const SECTION_SELECTOR = '[data-tv-size-popup]';
  const TRIGGER_SELECTOR = '[data-open-tv-size-popup]';
  const instances = new Map();
  const LINE_HEIGHTS = {
    desktop: {
      '5.5': 70,
      '6.5': 80,
      '7.5': 92,
      '8.5': 108,
      '9.8': 128,
      '11.5': 148,
    },
    mobile: {
      '5.5': 24,
      '6.5': 36,
      '7.5': 48,
      '8.5': 60,
      '9.8': 72,
      '11.5': 84,
    },
  };

  function initPopup(section) {
    if (instances.has(section)) return instances.get(section);
    const optionButtons = Array.from(section.querySelectorAll('[data-option-index]'));
    if (!optionButtons.length) return;
    const controller = new AbortController();
    const listenerOptions = { signal: controller.signal };
    const entry = { controller, frame: null, refresh: null };

    const tvSize = section.querySelector('[data-tv-size]');
    const visualDistance = section.querySelector('[data-visual-distance]');
    const distanceLine = section.querySelector('.tv-size-popup__distance-line');
    const ctaButton = section.querySelector('[data-cta-button]');
    const closeButtons = Array.from(section.querySelectorAll('[data-close-popup]'));
    const activeClass = 'is-active';
    const dialog = section.querySelector('.tv-size-popup__dialog');

    function isMobileLayout() {
      if (!dialog) return window.innerWidth <= 989;
      const direction = window.getComputedStyle(dialog).flexDirection || '';
      return direction.includes('column');
    }

    function getDistanceKey(rawDistance) {
      const parsed = Number.parseFloat(rawDistance);
      if (!Number.isFinite(parsed)) return '7.5';
      return parsed.toFixed(1);
    }

    function getLineHeight(distanceKey, mobile) {
      const table = mobile ? LINE_HEIGHTS.mobile : LINE_HEIGHTS.desktop;
      return table[distanceKey] || table['7.5'];
    }

    function activate(button, mobile = isMobileLayout()) {
      if (!button) return;
      optionButtons.forEach((item) => item.classList.remove(activeClass));
      button.classList.add(activeClass);

      const sizeValue = button.dataset.size || '';
      const distanceValue = button.dataset.distance || '';
      const ctaUrl = button.dataset.ctaUrl || '#';
      const ctaText = button.dataset.ctaText || '';
      const distanceKey = getDistanceKey(button.dataset.distanceFeet || distanceValue);

      if (tvSize) tvSize.textContent = sizeValue;
      if (visualDistance) visualDistance.textContent = `${distanceValue} DISTANCE`;
      if (distanceLine) {
        distanceLine.style.setProperty('--distance-line-height', `${getLineHeight(distanceKey, mobile)}px`);
      }
      if (ctaButton) {
        ctaButton.setAttribute('href', ctaUrl);
        ctaButton.textContent = ctaText;
      }
    }

    function getDefaultOption(mobile) {
      const mobilePreferredOption = mobile
        ? optionButtons.find((button) => {
            const distance = getDistanceKey(button.dataset.distanceFeet || button.dataset.distance || '');
            return distance === '7.5';
          })
        : null;

      return (
        mobilePreferredOption ||
        optionButtons.find((button) => button.dataset.defaultActive === 'true') ||
        optionButtons[0]
      );
    }

    optionButtons.forEach((button) => {
      button.addEventListener('click', () => activate(button), listenerOptions);
    });

    entry.refresh = (reset = false) => {
      // Read layout once before changing classes, text or inline styles.
      const mobile = isMobileLayout();
      const button = reset ? getDefaultOption(mobile)
        : section.querySelector(`[data-option-index].${activeClass}`) || getDefaultOption(mobile);
      activate(button, mobile);
    };
    instances.set(section, entry);
    section.dataset.popupInitialized = 'true';
    entry.refresh(true);

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        section.classList.remove('is-visible');
      }, listenerOptions);
    });

    section.addEventListener('click', (event) => {
      if (event.target === section.querySelector('.tv-size-popup__overlay')) {
        section.classList.remove('is-visible');
      }
    }, listenerOptions);

    section.addEventListener('tv-size-popup:reset', () => {
      entry.refresh(true);
    }, listenerOptions);

    window.addEventListener('resize', () => {
      if (!section.classList.contains('is-visible') || entry.frame !== null) return;
      entry.frame = window.requestAnimationFrame(() => {
        entry.frame = null;
        if (section.isConnected && section.classList.contains('is-visible')) entry.refresh();
      });
    }, listenerOptions);
    return entry;
  }

  function openPopupById(targetId) {
    const popup =
      (targetId && document.getElementById(targetId)) || document.querySelector(SECTION_SELECTOR);
    if (!popup) return;
    const existing = instances.has(popup);
    popup.classList.add('is-visible');
    const entry = initPopup(popup);
    if (existing && entry) entry.refresh(true);
  }

  function initTriggers() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(TRIGGER_SELECTOR);
      if (!trigger) return;
      event.preventDefault();
      openPopupById(trigger.dataset.popupTarget);
    });

    document.addEventListener('tv-size-popup:open', (event) => {
      const popupId = event.detail && event.detail.popupId;
      openPopupById(popupId);
    });
  }

  function initAll() {
    instances.forEach((entry, section) => {
      if (!section.isConnected) releasePopup(section, entry);
    });
    document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      // Hidden popups need no layout work until the first open.
      if (section.classList.contains('is-visible')) initPopup(section);
    });
  }

  function releasePopup(section, entry) {
    entry.controller.abort();
    window.cancelAnimationFrame(entry.frame);
    instances.delete(section);
    delete section.dataset.popupInitialized;
  }

  initTriggers();
  window.tclTvSizePopup = { init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((entry, section) => {
      if (event.target === section || event.target.contains(section)) releasePopup(section, entry);
    });
  });
})();
